<template>
  <div>
    <div v-if="breadcrumb.length > 0" class="breadcrumb w-full" itemscope itemtype="https://schema.org/BreadcrumbList">
      <span v-for="(item, key) in breadcrumb" itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
        <router-link v-if="key < breadcrumb.length - 1" tag="a" :to="item" class="text-sm text-grey-darker no-underline" itemprop="item">
          <span itemprop="name">{{ item.meta.title }}</span>
          <meta itemprop="position" :content="(key + 1)" />
        </router-link>
        <span v-else class="text-sm text-grey-darker no-underline" itemprop="item">
          <span itemprop="name">{{ item.meta.title }}</span>
          <meta itemprop="position" :content="(key + 1)" />
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import endpoints from '../endpoints'
import axios from 'axios'
import { mapGetters } from 'vuex'
import { mapFields } from 'vuex-map-fields'

export default {
  name: 'Breadcrumb',

  data () {
    return {
      breadcrumb: [],
      errors: []
    }
  },

  computed: {
    ...mapGetters([
      'getBasket'
    ]),

    ...mapFields([
      'content.item_geoid'
    ])
  },

  watch: {
    $route () {
      this.update()
    }
  },

  created () {
    this.update()
  },

  methods: {
    update () {
      this.breadcrumb = []

      if (this.$router.history.current.path !== '/') {
        this.breadcrumb = [{
          path: '/',
          meta: {
            title: 'Startseite'
          }
        }]

        this.breadcrumb.push({
          path: this.$router.history.current.path,
          name: this.$router.history.current.name,
          meta: this.$router.history.current.meta,
          param: this.$router.history.current.params
        })
      }

      this.addLocation()
      this.addHost()
      this.addReview()
    },

    addLocation () {
      if ((this.$router.history.current.name === 'Shop' || this.$router.history.current.name === 'Bewertungen' || this.$router.history.current.name === 'Anbieter') && this.item_geoid > 0) {
        axios.post(endpoints.lastlocation, { query: this.item_geoid })
          .then(response => {
            this.breadcrumb.splice(1, 0, {
              path: '/anbieter/' + response.data.item_url,
              meta: {
                title: response.data.item_ort_einfach
              }
            })
          })
      }
    },

    addHost () {
      this.$nextTick(() => {
        if (this.$router.history.current.name === 'Warenkorb' || this.$router.history.current.name === 'Shop' || this.$router.history.current.name === 'Bewertungen') {
          axios.post(endpoints.hostdescription, {
            'hostUrl': this.$route.params.hostUrl
          })
            .then(({data}) => {
              this.breadcrumb.splice(1, 0, {
                path: '/shop/' + this.$route.params.hostUrl,
                meta: {
                  title: data.name
                }
              })
            })
        }
      })
    },

    addReview () {
      if (this.$router.history.current.name === 'Bewerten') {
        this.breadcrumb.splice(1, 0, {
          path: '/archiv',
          meta: {
            title: 'Bestellhistorie'
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .breadcrumb {
    > span {
      @apply text-grey-dark;

      &:before {
        content: ' » ';
      }

      &:first-child {
        &:before {
          content: '';
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb.vue